import { FeatureFlagMap } from "@/types/featureFlag"

/**
 * Default feature flag values — used as fallback while flags load from the server
 * or when FeatureFlagProvider is unavailable.
 */
export const DEFAULT_FLAGS: FeatureFlagMap = {
  CHAT_HISTORY: false,
  CHAT_RATE_LIMIT: false,
  WEB_SEARCH: false,
  EXCEL_INTELLIGENCE: false,
  // Rollout: the new canvas Excel editor in every Excel preview (off = Fortune Sheet).
  EXCEL_EDITOR_V2: false,
  PDF_INTELLIGENCE: false,
  USE_EXTEND: false,
  SHAREPOINT: false,
  KB_TAGGING_FLOW: false,
  RAG_V2_CHAT: false,
  RAG_V2_DOCUMENTS: false,
  RAG_V2_QUESTIONNAIRES: false,
  ANSWERING_CONTEXT: false,
  COMPLIANCE: false,
  QMS_SIMULATOR: false,
  COMPANY_PROFILE: false,
  QMS_4_1: false,
  MATERIAL_COMPLIANCE: false,
  COMPANY_INDEX: false,
  COMPANY_INDEX_ARTICLE_HANDOFF: false,
  USE_ANCHORED_PROD: false,
  CHAT_PDF_DOWNLOAD: false,
  TEAM_MANAGEMENT: false,
  MC_MASTER_DATA: false,
  MC_MASTER_DATA_RESET: false,
  MC_ERP_IMPORT: false,
  MC_MASTER_DATA_SUPPLIERS: false,
  MC_MASTER_DATA_ARTICLES: false,
  MC_MASTER_DATA_SUBSTANCES: false,
  MC_MASTER_DATA_SUBSTANCE_EDIT: false,
  MC_MASTER_DATA_PRODUCTS: false,
  MC_MASTER_DATA_CUSTOMERS: false,
  MC_CUSTOMER_STUDIO: false,
  MC_CUSTOMER_STUDIO_DASHBOARD: false,
  MC_CUSTOMER_STUDIO_REQUESTS: false,
  MC_CUSTOMER_STUDIO_CONFORMITY: false,
  MC_CONFORMITY_EMAIL_SEND: false,
  MC_CONFORMITY_BLOCK_EDITOR: false,
  MC_CONFORMITY_GENERAL: false,
  MC_DECLARATION_TEMPLATES: false,
  MC_REGULATION_SETTINGS: false,
  MC_SUPPLIER_STUDIO: false,
  MC_SUPPLIER_STUDIO_DASHBOARD: false,
  MC_SUPPLIER_STUDIO_DECLARATIONS: false,
  MC_SUPPLIER_STUDIO_INQUIRY: false,
  MC_STATEMENT_RESET: false,
  MC_APPROVE_PRECHECK: false,
  MC_REVIEW_FAST_OPEN: false,
  MC_SUPPLIER_REASSIGN: false,
  MC_MASTER_DATA_MANUFACTURER_FILTER: false,
  MC_ISSUER_SCOPE_PROPOSAL: false,
  MC_SUPPLIER_MATCH_STRICT: false,
  MC_REVIEW_PAGED: false,
  MC_DECLARATION_TABLES: false,
  TURNUS_MEMORY: false,
  MC_HOME: false,
  MC_DECLARATION_INQUIRY: false,
  MC_NOTES: false,
  NOTIFICATIONS_IN_APP: false,
  NOTIFICATIONS_EMAIL: false,
  ENABLE_SIDECHAT: false,
  AGENT_TOOLS: false,
  HELPDESK: false,
  HELPDESK_EDIT: false,
  CHAT_FILE_UPLOAD: false,
  SIDEBAR_V2: false,
  SIDEBAR_MC_ONLY: false,
  AUTO_PILOTS_INTERNAL: false,
  EXTENSION_ENABLED: false,
  EXTENSION_HISTORY: false,
  EXTENSION_DOCUMENT_SELECTION: false,
  EXTENSION_FULL_PAGE_SCAN: false,
  EXTENSION_SIDEBAR_VIEW: false,
  EXTENSION_AUTO_GENERATE: false,
  EXTENSION_AUTO_FILL: false,
  EXTENSION_DIFF_REVIEW: false,
  EXTENSION_MULTI_QUESTION_MODES: false,
  EXTENSION_CONFIDENCE_DETAILS: false,
  ENABLE_ORG_SIGNATURES: false,
  ONBOARDING_TOUR: false,
  ONBOARDING_VIDEO_TOUR: false,
  ONBOARDING_DATA_ROOM: false,
}
